import {
  FeatureAction,
  FeatureKey,
  FeaturePermission,
  useContextualFeaturePermissionQuery
} from "@pathwright/graphql-client/src/generated"
import Alert from "@pathwright/ui/src/components/alert/Alert"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import { getFeatureInfo, getFeaturePermissionInfo } from "../utils"
import FeatureBlockUI, { FeatureBlockUIProps } from "./FeatureBlockUI"

const HomeScreenFeatureBlockContainer = (
  props: Pick<FeatureBlockUIProps, "to" | "description">
) => {
  const { t } = useTranslate()
  const launchQuery = useContextualFeaturePermissionQuery({
    variables: {
      featureKey: FeatureKey.HomeScreenUnified,
      featureAction: FeatureAction.HomeScreenView,
      context: null
    }
  })
  const previewQuery = useContextualFeaturePermissionQuery({
    variables: {
      featureKey: FeatureKey.HomeScreenPreview,
      featureAction: FeatureAction.View,
      context: null
    }
  })

  if (launchQuery.loading || previewQuery.loading) return null
  const error = launchQuery.error || previewQuery.error
  if (error) return <Alert error={error} />

  const launched =
    launchQuery.data?.contextualFeaturePermission?.permission_in_context ===
    FeaturePermission.Everyone
  const previewPermission =
    previewQuery.data?.contextualFeaturePermission?.permission_in_context ??
    FeaturePermission.Disabled

  return (
    <FeatureBlockUI
      {...props}
      featureInfo={getFeatureInfo(FeatureKey.HomeScreenUnified, t)}
      featurePermissionInfo={
        launched
          ? { icon: "rocket", title: t("Launched") }
          : getFeaturePermissionInfo(
              FeatureKey.HomeScreenPreview,
              previewPermission,
              t
            )
      }
    />
  )
}

export default HomeScreenFeatureBlockContainer
